<template>
  <div>
    <h3 class="title">Vòng quay may mắn</h3>
    <div class="info" style="margin-top: 10px">
      <span class="sub-info">Mỗi tài khoản có 01 lượt quay/ mã lớp đăng ký học.</span>
      <span class="sub-info">Phần quà voucher được áp dụng riêng cho khóa học đăng ký quay thưởng.</span>
      <span class="sub-info">Khi lớp đã đủ sĩ số, không thể đăng ký để quay thưởng.</span>
      <span class="sub-info">Thời gian quay thưởng: 06/06/2024  - 10/06/2024</span>
    </div>
    <div class="bg-blue mt-[20px] p-2 rounded-2xl md:p-6">
      <h3 class="title">Lịch sử quà tặng</h3>
      <div class="history-table">
        <div class="grid grid-cols-1 gap-3 lg:grid-cols-2 xl:gap-6">
          <button
              class="btn-history border-0"
              @click="$emit('history')"
              :class="isHistory ? 'btn-active' : 'btn-unActive'"
          >LỊCH SỬ QUÀ TẶNG</button>
          <button
              class="btn-history border-0"
              @click="$emit('myGift')"
              :class="!isHistory ? 'btn-active' : 'btn-unActive'"
          >QUÀ TẶNG CỦA TÔI</button>
        </div>
        <div class="overflow-x-auto table-responsive" style="margin-top: 15px">
          <table class="table table-md overflow-hidden w-full text-[14px]">
            <thead v-if="!isMobile">
              <tr v-if="isHistory" class="text-white border-0 rounded-full py-2">
                <th  class="px-5 text-left lg:w-1/4 w-fit bg-[#2382F3] rounded-l-full">Họ và tên</th>
                <th  class="text-center min-w-[150px] sm:w-fit bg-[#2382F3]">Số điện thoại</th>
                <th  class="text-center bg-[#2382F3]">Phần Quà</th>
                <th  class="text-right min-w-[150px] pr-5 bg-[#2382F3] rounded-r-full">Thời gian</th>
              </tr>
              <tr v-else class="text-white border-0 text-center bg-[#2382F3] rounded-full py-2">
                <th class="bg-[#2382F3] rounded-l-full">Phần Quà</th>
                <th class="bg-[#2382F3]">Mã lớp đăng ký</th>
                <th class="text-center bg-[#2382F3] rounded-r-full">Thời gian</th>
              </tr>
            </thead>
            <thead v-else>
              <tr v-if="isHistory" class="text-white border-0 rounded-full">
                <th  class="px-8 text-left w-fit bg-[#2382F3] rounded-l-full">
                  <span>Họ và tên</span>
                  <br/>
                  <span>Phần Quà</span>
                </th>
                <th  class="text-center min-w-[150px] sm:w-fit bg-[#2382F3] rounded-r-full px-8">
                  <span>Số điện thoại</span><br/> <span>Thời gian</span></th>
              </tr>
              <tr v-else class="text-white border-0 text-center bg-[#2382F3] rounded-full">
                <th class="bg-[#2382F3] rounded-l-full">Phần Quà</th>
                <th class="bg-[#2382F3]">Mã lớp đăng ký</th>
                <th class="text-center bg-[#2382F3] rounded-r-full">Thời gian</th>
              </tr>
            </thead>
            <tbody class="overflow-y-auto max-h-[200px]">
            <template v-if="isHistory && isMobile">
              <tr v-for="(item, key) in dataTable" :key="key" class="text-white">
                <td v-bind:key="key" class="p-5">
                  {{ item.name }}
                  <br/>
                  {{ item.gif }}
                </td>
                <td v-bind:key="key" class="p-5">
                  {{ item.phone }}
                  <br/>
                  {{ item.time }}
                </td>
              </tr>
            </template>
            <template v-if="isHistory && !isMobile">
              <tr v-for="(item, key) in dataTable" :key="key" class="text-white">
                <td v-bind:key="key" v-text="item.name" class="p-5"></td>
                <td v-bind:key="key" v-text="item.phone" class="p-5 text-center"></td>
                <td v-bind:key="key" v-text="item.gif" class="p-5 text-center"></td>
                <td v-bind:key="key" v-text="item.time" class="p-5 text-end"></td>
              </tr>
            </template>
            <template v-else-if="!isHistory && isLogin">
              <tr v-for="(item, key) in dataGift" :key="key" class="text-white text-center">
                <td v-bind:key="key" v-text="item?.gift" class="p-3"></td>
                <td v-bind:key="key" v-text="item?.classroom" class="p-3"></td>
                <td v-bind:key="key" v-text="item?.time" class="p-3 text-center"></td>
              </tr>
            </template>
            <template v-else-if="!isLogin && !isHistory">
              <tr class="h-[100px]" style="width: 100%; position: relative">
                <td class="text-center w-100" style="position: absolute; left: 50%; top:50%; translate: -50% -50%; color: white">Vui lòng đăng nhập để xem thông tin này!</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    dataTable: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    },
    isHistory: {
      type: Boolean,
      default: false
    },
    dataGift: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style lang="css" scoped>
  .title {
    color: #01518E;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: start;
  }
  .sub-info {
    font-size: 18px;
  }
  .history-table {
    background: #01518E;
    padding: 30px;
    border-radius: 30px;
  }
  .btn-history {
    width: 100%;
    border-radius: 9999px;
    font-size: 20px;
    font-weight: bold;
    padding: 6px 0;
  }
  .btn-active {
    background: #FFD602;
    color: #01518E;
    border: 0;
  }
  .btn-unActive {
    border: 0;
    background: white;
    color: #01518E;
  }
</style>